import React, {useState} from 'react';
import {DELIVERY_PAGES} from "../JobOrderDeliveryPage";
import {toast} from "react-toastify";
import Card from "../../components/Card";
import CreateEditDelivery from "../../components/job/delivery/CreateEditDelivery";

const JobOrderDeliveryCreateEditPage = (props) => {
    const {
        jobId           = null,
        orderId         = null,
        deliveryId      = null,
        parentId        = "",
        onChangePage    = (INDEX, delivery) => {}
    } = props;

    const handleClickBack = (event) => {
        event.preventDefault();
        onChangePage(DELIVERY_PAGES.INDEX, null);
    }

    const handleCancel = () => {
        onChangePage(DELIVERY_PAGES.INDEX, null);
    }

    const handleComplete = (delivery) => {
        if (!!deliveryId) {
            toast.success(<div>{"Delivery updated."}</div>);
        } else {
            toast.success(<div>{"Delivery created."}</div>);
        }

        onChangePage(DELIVERY_PAGES.INDEX, null);
    }

    const handleDelete = () => {
        toast.success(<div>{"Delivery deleted."}</div>);

        onChangePage(DELIVERY_PAGES.INDEX, null);
    }

    return (
        <React.Fragment>
            <Card
                title={!!deliveryId ? "Edit Delivery" : "Create Delivery"}
                classes={"mh-100 border-0"}
                controls={can('viewAny', 'delivery') ? (
                    <button
                        onClick={(event) => handleClickBack(event)}
                        className={"btn font-weight-bold btn-outline-eh-off-black px-4 m-0"}
                    >
                        <i className={"fa fa-chevron-left mr-2"} />
                        <span>{"Back"}</span>
                    </button>
                ) : null}
            >
                <CreateEditDelivery
                    jobId={jobId}
                    orderId={orderId}
                    deliveryId={deliveryId}
                    onCancel={() => handleCancel()}
                    onComplete={(delivery) => handleComplete(delivery)}
                    onDelete={() => handleDelete()}
                    parentId={parentId}
                />
            </Card>
        </React.Fragment>
    );
}

export default JobOrderDeliveryCreateEditPage;
